import axios from "axios";
import { getCookie } from "../../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;
const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getTripPlanRouteApi = async (tripId) => {
  try {
    var payload = { table_name: "transport_trips", id: tripId };
    const response = await axios.post(
      adminUrl + `get_gmap_direction`,
      payload,
      {
        headers: header,
      }
    );
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTripHistoryRouteApi = async (tripId) => {
  try {
    var payload = { table_name: "transport_trip_history", id: tripId };
    const response = await axios.post(
      adminUrl + `get_gmap_direction`,
      payload,
      {
        headers: header,
      }
    );
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const fetchActualRouteApi = async (tripId) => {
  try {
    var payload = { trip_id: tripId };
    const response = await axios.post(apiUrl + `fetch_actual_route`, payload, {
      headers: header,
    });
    console.log("fetchActualRouteApi response:", response);
    return response;
  } catch (err) {
    console.error("Error fetching actual route:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getStopLocationsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `get_trip/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getDeliveryLocationsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `get_actual_plot/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getStopsListApi = async (id, status, term) => {
  try {
    const response = await axios.get(
      apiUrl + `get_status_stops/${id}?status=${status}&search=` + term,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getLiveVehiclesApi = async (status) => {
  try {
    const response = await axios.get(apiUrl + `get_trips?status=` + status, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
